import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'

interface HeaderProps {
  title?: string
  showSearch?: boolean
}

export function Header({ title, showSearch = true }: HeaderProps) {
  return (
    <header className="sticky top-0 z-10 flex h-14 items-center gap-4 border-b bg-background px-6">
      {title && <h1 className="text-lg font-semibold">{title}</h1>}

      <div className="flex-1" />

      {showSearch && <div className="relative w-64">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder="Search symbols..."
          className="pl-8"
        />
      </div>}
    </header>
  )
}
